import { FC } from "react";
import { useSetRecoilState } from "recoil";
import { customJSONPrintManagerAtom } from "./CustomJSONPrintManagerAtoms";
import { Button } from "../TrueUI";
import CustomJSONPrintManager from "./CustomJSONPrintManager";
import Link from "../TrueUI/Typography/Link";
import { KeysAsType } from "../../types/KeysAsAType";
import { FontsType } from "../../media/themeTypes";

export type CustomJSONPrintProps = {
  templateName: string;
  templatePath?: string;
  customFileName: string;
  customJSONType: number;
  sourceIDToBuildJSON_1: number;
  sourceIDToBuildJSON_2?: number;
  isDisabled?: boolean;
  text?: string;
  variantStyle?: "contained" | "outlined" | "text";
  component?: "button" | "link";
  linkFontType?: KeysAsType<FontsType>;
  name?: string;
  sx?: any;
};

const CustomJSONPrintComponent: FC<CustomJSONPrintProps> = ({
  templateName,
  templatePath = "",
  customFileName,
  customJSONType,
  sourceIDToBuildJSON_1,
  sourceIDToBuildJSON_2,
  isDisabled,
  text = "PRINT",
  variantStyle,
  component = "button",
  sx,
  linkFontType,
  name,
}) => {
  const setCustomJSONPrintManagerAtom = useSetRecoilState(
    customJSONPrintManagerAtom
  );

  const onClickPrint = () => {
    setCustomJSONPrintManagerAtom({
      customJSONType: customJSONType,
      sourceIDToBuildJSON_1: sourceIDToBuildJSON_1,
      sourceIDToBuildJSON_2: sourceIDToBuildJSON_2,
      configurationRequest: {
        formRelativePath: templatePath,
        templateNameWithExtensionList: [templateName ?? ""],
        customFileName: customFileName,
      },
    });
  };

  const renderComponent = () => {
    switch (component) {
      case "link":
        return (
          <Link
            linkFontType={linkFontType}
            displayValue={text}
            name={name}
            onClick={onClickPrint}
          />
        );
      default:
        return (
          <Button
            sx={sx}
            name={name}
            isDisabled={isDisabled}
            onClick={onClickPrint}
            variantStyle={variantStyle}
          >
            {text}
          </Button>
        );
    }
  };
  return (
    <>
      {renderComponent()}
      <CustomJSONPrintManager />
    </>
  );
};
export default CustomJSONPrintComponent;
